'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isType = exports.isType = function isType(type) {
  return function (obj) {
    return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) == type;
  };
};

var isString = exports.isString = function isString(obj) {
  return isType('string')(obj);
};
var isArray = exports.isArray = function isArray(obj) {
  return isType('object')(obj) && !!obj.slice;
};
var isFunction = exports.isFunction = function isFunction(obj) {
  return isType('function')(obj);
};
var isBoolean = exports.isBoolean = function isBoolean(obj) {
  return isType('boolean')(obj);
};
var isPlainObject = exports.isPlainObject = function isPlainObject(obj) {
  return isType('object')(obj) && !isArray(obj);
};
var isUndefined = exports.isUndefined = function isUndefined(obj) {
  return isType('undefined')(obj);
};
var isPromise = exports.isPromise = function isPromise(o) {
  return o instanceof Promise;
};
var isReg = exports.isReg = function isReg(o) {
  return o instanceof RegExp;
};

var noop = exports.noop = function noop() {};